import { Font, StyleSheet } from "@react-pdf/renderer";
import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    width: "100%",
    flexDirection: "row",
    lineHeight: "1.7",
  },
  arrowIconCont: {
    fontSize: "6px",
    color: "#FF0000",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "12px",
    height: "15px",
  },
  landscapeLeft: {
    flexDirection: "row",
    width: "50%",
    padding: "57px 17px",
  },
  landscapeRight: {
    flexDirection: "row",
    width: "50%",
    padding: "57px 17px",
  },
  pointingText: {
    marginBottom: "6px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument7 = (props) => {
  let { arabChunks, engChunks } = props;
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  let landscapePagesArray = [];
  const landscapePages = () => {
    let k = 0,
      m = 1;
    for (let i = 1; i < 4; i++) {
      landscapePagesArray.push(
        <>
          <View style={Styles.landscapeLeft}>
            <View style={{ width: "40px" }}>
              <View style={[Styles.arrowIconCont, { marginRight: "6px" }]}>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                ></Image>
              </View>
            </View>
            <View style={{ width: "80%" }}>
              <View
                style={{
                  height: "225px",
                  marginBottom: "30px",
                }}
              >
                {engChunks[i + k]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
              <View
                style={[
                  {
                    height: "225px",
                    overflow: "hidden",
                    textAlign: "right",
                  },
                ]}
              >
                {arabicText(arabChunks[i + k])}
              </View>
            </View>
            <View style={{ width: "40px", marginLeft: "6px" }}>
              <View
                style={[
                  Styles.arrowIconCont,
                  { position: "absolute", top: "51%" },
                ]}
              >
                <Image
                  src="/images/leftcurvepdf_arrow.png"
                  style={Styles.curveArrowIcon}
                ></Image>
              </View>
            </View>
          </View>
          <View style={Styles.landscapeRight}>
            <View style={{ width: "40px", marginRight: "6px" }}>
              <View>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                ></Image>
              </View>
            </View>
            <View style={{ width: "80%" }}>
              <View
                style={{
                  height: "225px",

                  marginBottom: "30px",
                }}
              >
                {engChunks[i + m]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
              <View
                style={[
                  {
                    height: "225px",
                    overflow: "hidden",
                    textAlign: "right",
                  },
                ]}
              >
                {arabicText(arabChunks[i + m])}
              </View>
            </View>
            <View style={{ width: "40px", marginLeft: "6px" }}>
              <View
                style={[
                  Styles.arrowIconCont,
                  { position: "absolute", top: "52%" },
                ]}
              >
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={Styles.arrowIcon}
                ></Image>
              </View>
            </View>
          </View>
        </>
      );
      m = m + 1;
      k = k + 1;
    }
  };
  landscapePages();
  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View
          style={{ width: "40px", marginRight: "6px", alignItems: "flex-end" }}
        >
          <View style={Styles.arrowIconCont}>
            <Text style={[Styles.pointingText, { marginTop: "-13px" }]}>
              Start of text
            </Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "80%" }}>
          <View
            style={{ height: "225px", textAlign: "left", marginBottom: "30px" }}
          >
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
          <View
            style={[
              {
                height: "225px",
                overflow: "hidden",
                textAlign: "right",
              },
            ]}
          >
            {arabicText(arabChunks[0])}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}>
          <View
            style={[Styles.arrowIconCont, { position: "absolute", top: "50%" }]}
          >
            <Text style={Styles.pointingText}>بداية النص</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
      {landscapePagesArray.map((array, index) => {
        return (
          <Page
            size="A4"
            style={Styles.landscapePage}
            orientation="landscape"
            key={index}
          >
            {array}
          </Page>
        );
      })}
      <Page size="A5" style={Styles.portraitPage}>
        <View style={{ width: "40px", marginRight: "6px" }}>
          <View style={Styles.arrowIconCont}>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
          <View
            style={[Styles.arrowIconCont, { position: "absolute", top: "93%" }]}
          >
            <Text style={Styles.pointingText}>نهاية النص</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
        </View>
        <View style={{ width: "80%" }}>
          <View style={{ height: "225px", marginBottom: "30px" }}>
            {engChunks[7]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
          <View
            style={[
              {
                height: "225px",
                overflow: "hidden",
                textAlign: "right",
              },
            ]}
          >
            {arabicText(arabChunks[7])}
          </View>
        </View>
        <View style={{ width: "40px", marginLeft: "6px" }}>
          <View
            style={[Styles.arrowIconCont, { position: "absolute", top: "44%" }]}
          >
            <Text style={Styles.pointingText}>End of text</Text>
            <Image
              src="/images/leftpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument7;
